import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import ModalidadSelector from '../components/registro/ModalidadSelector.jsx';
import NicknameOptions from '../components/registro/NicknameOptions.jsx';
import DocumentUploader from '../components/registro/DocumentUploader.jsx';
import imgPortada1 from '../images/portada/fo1.jpg';
import imgPortada2 from '../images/14.jpg';
import imgPortada3 from '../images/26.jpg';
import imgCcFront from '../images/CC_identidad/CC_front.png';
import imgCcBack from '../images/CC_identidad/CC_back.png';
import imgCcSelfie from '../images/CC_identidad/CC_girl.png';
import '../styles/RegistroPage.css';
import '../styles/RegistroSatelite.css';

const REGISTRO_HERO_IMAGES = [
  { src: imgPortada1, alt: 'TM Studio' },
  { src: imgPortada2, alt: 'TM Studio' },
  { src: imgPortada3, alt: 'TM Studio' },
];
const CAROUSEL_INTERVAL_MS = 4500;

const CIUDADES = ['Seleccione Ciudad', 'Cali', 'Medellín', 'Pereira', 'Cúcuta', 'Bogotá', 'Otras ciudades'];
const COMO_ENTERASTE = [
  { value: '', label: 'Seleccione una opción' },
  { value: 'ig', label: 'Instagram' },
  { value: 'fb', label: 'Facebook' },
  { value: 'ad', label: 'Publicidad' },
  { value: 'ref', label: 'Referido' },
];
const DIAS = Array.from({ length: 31 }, (_, i) => i + 1);
const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const ANOS = Array.from({ length: 30 }, (_, i) => new Date().getFullYear() - 18 - i);

const TIPOS_CUENTA = [
  { value: '', label: 'Seleccione tipo de cuenta' },
  { value: 'model-solo', label: 'Model@ sol@' },
  { value: 'pareja', label: 'Pareja' },
  { value: 'grupal', label: 'Grupal' },
];
const PLATAFORMAS = [
  { value: '', label: 'Seleccione plataforma' },
  { value: 'chaturbate', label: 'Chaturbate' },
  { value: 'stripchat', label: 'Stripchat' },
  { value: 'cam4', label: 'Cam4' },
  { value: 'bongacams', label: 'Bongacams' },
];
const GENEROS = [
  { value: '', label: 'Seleccione género' },
  { value: 'mujer', label: 'Mujer' },
  { value: 'hombre', label: 'Hombre' },
  { value: 'mujer-trans-f2m', label: 'Mujer Trans (F2M)' },
  { value: 'hombre-trans-m2f', label: 'Hombre Trans (M2F)' },
];

const DOC_GUIDE_BULLETS = [
  '✓ Imagen clara y legible',
  '✓ Documento completo en el encuadre',
  '✗ No editar ni recortar de forma que oculte datos',
];

const DOC_GUIDE_SELFIE_BULLETS = [
  'Rostro visible y documento legible',
  'Documento junto al rostro',
  'No usar filtros',
];

function validateNickOpciones(nickOpciones) {
  const filled = nickOpciones.map((s) => String(s || '').trim()).filter(Boolean);
  if (filled.length === 0) return 'Ingresa al menos una opción de nick.';
  for (const n of filled) {
    if (n.length < 2) return 'Cada nick indicado debe tener al menos 2 caracteres.';
  }
  return '';
}

function RegistroPage() {
  const [modalidad, setModalidad] = useState('principal');
  const [formData, setFormData] = useState({
    nombre: '', email: '', comoEnteraste: '', dia: '', mes: '', ano: '', telefono: '', instagram: '',
    experiencia: '', ciudad: '', mensaje: '', mayorEdad: false,
    tipoCuenta: '', plataforma: '', genero: '',
  });
  const [nickOpciones, setNickOpciones] = useState(['', '', '']);
  const [fotoRostro, setFotoRostro] = useState(null);
  const [fotoCuerpo, setFotoCuerpo] = useState(null);
  const [docFrente, setDocFrente] = useState(null);
  const [docReverso, setDocReverso] = useState(null);
  const [docSelfie, setDocSelfie] = useState(null);
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [errorEnvio, setErrorEnvio] = useState('');
  const [heroSlideIndex, setHeroSlideIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlideIndex((prev) => (prev + 1) % REGISTRO_HERO_IMAGES.length);
    }, CAROUSEL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (modalidad === 'principal') {
      setDocFrente(null);
      setDocReverso(null);
      setDocSelfie(null);
      setNickOpciones(['', '', '']);
      setFormData((p) => ({
        ...p,
        tipoCuenta: '',
        plataforma: '',
        genero: '',
      }));
    }
  }, [modalidad]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleFileRostro = (e) => {
    const file = e.target.files?.[0];
    if (file) setFotoRostro(file);
  };

  const handleFileCuerpo = (e) => {
    const file = e.target.files?.[0];
    if (file) setFotoCuerpo(file);
  };

  const uploadFileToS3 = async (file, slot) => {
    const presignRes = await fetch('/api/registrations/presign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: file.name || 'foto.jpg',
        contentType: file.type || 'image/jpeg',
        slot,
      }),
    });
    const presignData = await presignRes.json().catch(() => ({}));
    if (!presignRes.ok) {
      throw new Error(presignData.error || 'No fue posible preparar la subida de imágenes');
    }

    const uploadRes = await fetch(presignData.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': presignData.contentType || file.type || 'application/octet-stream' },
      body: file,
    });
    if (!uploadRes.ok) {
      throw new Error('No fue posible subir las imágenes');
    }

    return {
      key: presignData.key,
      fileUrl: presignData.fileUrl,
    };
  };

  const uploadSateliteFile = async (file, slot) => {
    const presignRes = await fetch('/api/registrations/satelite/presign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: file.name || 'foto.jpg',
        contentType: file.type || 'image/jpeg',
        slot,
      }),
    });
    const presignData = await presignRes.json().catch(() => ({}));
    if (!presignRes.ok) {
      throw new Error(presignData.error || 'No fue posible preparar la subida (satélite)');
    }
    const uploadRes = await fetch(presignData.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': presignData.contentType || file.type || 'application/octet-stream' },
      body: file,
    });
    if (!uploadRes.ok) {
      throw new Error('No fue posible subir un archivo');
    }
    return { key: presignData.key, fileUrl: presignData.fileUrl };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorEnvio('');
    if (!formData.mayorEdad) {
      alert('Debes certificar que eres mayor de edad (+18).');
      return;
    }
    if (!formData.nombre.trim() || !formData.email.trim() || !formData.telefono.trim()) {
      alert('Completa los campos obligatorios: Nombre, Email y Teléfono.');
      return;
    }

    if (modalidad === 'principal') {
      if (!fotoRostro || !fotoCuerpo) {
        alert('Debes adjuntar foto de rostro y foto de cuerpo entero.');
        return;
      }
      setEnviando(true);
      try {
        const [rostroUpload, cuerpoUpload] = await Promise.all([
          uploadFileToS3(fotoRostro, 'rostro'),
          uploadFileToS3(fotoCuerpo, 'cuerpo'),
        ]);
        const payload = {
          nombre: formData.nombre,
          email: formData.email,
          telefono: formData.telefono,
          instagram: formData.instagram,
          comoEnteraste: formData.comoEnteraste,
          fechaNacimiento: `${formData.ano}-${String(formData.mes).padStart(2, '0')}-${String(formData.dia).padStart(2, '0')}`,
          experiencia: formData.experiencia,
          ciudad: formData.ciudad,
          mensaje: formData.mensaje,
          mayorEdad: formData.mayorEdad,
          fotoRostroKey: rostroUpload.key,
          fotoRostroUrl: rostroUpload.fileUrl,
          fotoCuerpoKey: cuerpoUpload.key,
          fotoCuerpoUrl: cuerpoUpload.fileUrl,
        };
        const res = await fetch('/api/registrations', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'No fue posible enviar la solicitud');
        setEnviado(true);
      } catch (err) {
        setErrorEnvio(err.message || 'Error de red al enviar la solicitud');
      } finally {
        setEnviando(false);
      }
      return;
    }

    /* Satélite */
    const nickErr = validateNickOpciones(nickOpciones);
    if (nickErr) {
      alert(nickErr);
      return;
    }
    if (!formData.tipoCuenta || !formData.plataforma || !formData.genero) {
      alert('Completa tipo de cuenta, plataforma y género.');
      return;
    }
    if (!docFrente || !docReverso || !docSelfie) {
      alert('Debes adjuntar las tres imágenes de documento (frente, reverso y selfie con documento).');
      return;
    }
    if (!fotoRostro || !fotoCuerpo) {
      alert('Debes adjuntar foto de rostro y foto de cuerpo entero.');
      return;
    }

    setEnviando(true);
    try {
      const [uFrente, uReverso, uSelfie, uRostro, uCuerpo] = await Promise.all([
        uploadSateliteFile(docFrente, 'doc-frente'),
        uploadSateliteFile(docReverso, 'doc-reverso'),
        uploadSateliteFile(docSelfie, 'selfie-doc'),
        uploadSateliteFile(fotoRostro, 'rostro'),
        uploadSateliteFile(fotoCuerpo, 'cuerpo'),
      ]);

      const payload = {
        modalidad: 'satelite',
        nombre: formData.nombre,
        email: formData.email,
        telefono: formData.telefono,
        instagram: formData.instagram,
        comoEnteraste: formData.comoEnteraste,
        fechaNacimiento: `${formData.ano}-${String(formData.mes).padStart(2, '0')}-${String(formData.dia).padStart(2, '0')}`,
        experiencia: formData.experiencia,
        ciudad: formData.ciudad,
        mensaje: formData.mensaje,
        mayorEdad: formData.mayorEdad,
        tipoCuenta: formData.tipoCuenta,
        plataforma: formData.plataforma,
        genero: formData.genero,
        nickOpciones: nickOpciones.map((s) => String(s || '').trim()),
        docFrenteKey: uFrente.key,
        docFrenteUrl: uFrente.fileUrl,
        docReversoKey: uReverso.key,
        docReversoUrl: uReverso.fileUrl,
        selfieDocKey: uSelfie.key,
        selfieDocUrl: uSelfie.fileUrl,
        fotoRostroKey: uRostro.key,
        fotoRostroUrl: uRostro.fileUrl,
        fotoCuerpoKey: uCuerpo.key,
        fotoCuerpoUrl: uCuerpo.fileUrl,
      };

      const res = await fetch('/api/registrations/satelite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'No fue posible enviar la solicitud');
      setEnviado(true);
    } catch (err) {
      setErrorEnvio(err.message || 'Error de red al enviar la solicitud');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <main className="tm-registro-page">
        <div className="tm-registro-layout">
          <div className="tm-registro-hero">
            <div className="tm-registro-hero-carousel">
              {REGISTRO_HERO_IMAGES.map((img, i) => (
                <div
                  key={i}
                  className={`tm-registro-hero-slide ${i === heroSlideIndex ? 'is-active' : ''}`}
                  aria-hidden={i !== heroSlideIndex}
                >
                  <img src={img.src} alt={img.alt} className="tm-registro-hero-img" />
                </div>
              ))}
            </div>
            <div className="tm-registro-hero-overlay" />
            <div className="tm-registro-hero-content">
              <h1 className="tm-registro-hero-brand">TMStudio</h1>
              <div className="tm-registro-hero-text">
                <p className="tm-registro-hero-badge">ES TU MOMENTO</p>
                <h2 className="tm-registro-hero-title">
                  Toma la <br />
                  <span className="tm-registro-hero-title-italic">decisión</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="tm-registro-form-wrap">
            <div className="tm-registro-progress-bar">
              <div className="tm-registro-progress-inner" style={{ width: '100%' }} />
            </div>
            <p className="tm-registro-progress-label">Paso 1 de 1: Información Personal</p>

            <div className="tm-registro-form-inner">
              <div className="tm-registro-form-header">
                <Link to="/" className="tm-registro-back">
                  <span className="material-symbols-outlined">arrow_back</span>
                  Regresa al inicio
                </Link>
              </div>

              <div className="tm-registro-form-title-wrap">
                <h3 className="tm-registro-form-title">Regístrate</h3>
                <p className="tm-registro-form-subtitle">* Por favor llenar los campos obligatorios *</p>
              </div>

              {enviado ? (
                <div className="tm-registro-success">
                  <span className="material-symbols-outlined tm-registro-success-icon">check_circle</span>
                  <h4>¡Solicitud enviada!</h4>
                  <p>Nos pondremos en contacto contigo pronto.</p>
                  <Link to="/" className="btn-hover gold-gradient-bg tm-registro-success-btn">Volver al inicio</Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="tm-registro-form">
                  {errorEnvio && (
                    <div className="tm-registro-error" role="alert">
                      {errorEnvio}
                    </div>
                  )}
                  <div className="tm-registro-grid">
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">Nombre Completo *</label>
                      <input
                        type="text"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        className="tm-registro-input"
                        placeholder="Ingrese nombres y apellidos"
                        required
                      />
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="tm-registro-input"
                        placeholder="Ingrese su email"
                        required
                      />
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">¿Cómo te enteraste? *</label>
                      <select
                        name="comoEnteraste"
                        value={formData.comoEnteraste}
                        onChange={handleChange}
                        className="tm-registro-input tm-registro-select"
                        required
                      >
                        {COMO_ENTERASTE.map((opt) => (
                          <option key={opt.value || 'x'} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">Fecha de Nacimiento *</label>
                      <div className="tm-registro-date-row">
                        <select name="dia" value={formData.dia} onChange={handleChange} className="tm-registro-input tm-registro-select tm-registro-date" required>
                          <option value="">Día</option>
                          {DIAS.map((d) => (
                            <option key={d} value={d}>{d}</option>
                          ))}
                        </select>
                        <select name="mes" value={formData.mes} onChange={handleChange} className="tm-registro-input tm-registro-select tm-registro-date" required>
                          <option value="">Mes</option>
                          {MESES.map((m, i) => (
                            <option key={m} value={i + 1}>{m}</option>
                          ))}
                        </select>
                        <select name="ano" value={formData.ano} onChange={handleChange} className="tm-registro-input tm-registro-select tm-registro-date" required>
                          <option value="">Año</option>
                          {ANOS.map((a) => (
                            <option key={a} value={a}>{a}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">Teléfono *</label>
                      <div className="tm-registro-prefix-wrap">
                        <span className="tm-registro-prefix">+57</span>
                        <input
                          type="tel"
                          name="telefono"
                          value={formData.telefono}
                          onChange={handleChange}
                          className="tm-registro-input tm-registro-input-prefix"
                          placeholder="Ingrese su teléfono"
                          required
                        />
                      </div>
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">Tu cuenta de Instagram</label>
                      <div className="tm-registro-prefix-wrap">
                        <span className="tm-registro-prefix tm-registro-prefix-at">@</span>
                        <input
                          type="text"
                          name="instagram"
                          value={formData.instagram}
                          onChange={handleChange}
                          className="tm-registro-input tm-registro-input-prefix"
                          placeholder="tucuenta"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="tm-registro-row">
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">¿Has trabajado antes? *</label>
                      <div className="tm-registro-radio-group">
                        <label className="tm-registro-radio-label">
                          <input type="radio" name="experiencia" value="si" checked={formData.experiencia === 'si'} onChange={handleChange} className="tm-registro-radio" required />
                          <span>Sí</span>
                        </label>
                        <label className="tm-registro-radio-label">
                          <input type="radio" name="experiencia" value="no" checked={formData.experiencia === 'no'} onChange={handleChange} className="tm-registro-radio" />
                          <span>No</span>
                        </label>
                      </div>
                    </div>
                    <div className="tm-registro-field">
                      <label className="tm-registro-label">¿De qué ciudad nos escribes? *</label>
                      <select name="ciudad" value={formData.ciudad} onChange={handleChange} className="tm-registro-input tm-registro-select" required>
                        {CIUDADES.map((c) => (
                          <option key={c} value={c === 'Seleccione Ciudad' ? '' : c}>{c}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <ModalidadSelector value={modalidad} onChange={setModalidad} />

                  {modalidad === 'satelite' && (
                    <div className="tm-reg-satelite-block">
                      <div className="tm-reg-satelite-row">
                        <div className="tm-registro-field">
                          <label className="tm-registro-label">Tipo de cuenta *</label>
                          <select name="tipoCuenta" value={formData.tipoCuenta} onChange={handleChange} className="tm-registro-input tm-registro-select" required={modalidad === 'satelite'}>
                            {TIPOS_CUENTA.map((o) => (
                              <option key={o.value || 'x'} value={o.value}>{o.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="tm-registro-field">
                          <label className="tm-registro-label">Plataforma *</label>
                          <select name="plataforma" value={formData.plataforma} onChange={handleChange} className="tm-registro-input tm-registro-select" required={modalidad === 'satelite'}>
                            {PLATAFORMAS.map((o) => (
                              <option key={o.value || 'x'} value={o.value}>{o.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <NicknameOptions
                        values={nickOpciones}
                        onChange={setNickOpciones}
                      />

                      <div className="tm-registro-field">
                        <label className="tm-registro-label">Género *</label>
                        <select
                          name="genero"
                          value={formData.genero}
                          onChange={handleChange}
                          className="tm-registro-input tm-registro-select"
                          required={modalidad === 'satelite'}
                        >
                          {GENEROS.map((g) => (
                            <option key={g.value || 'x'} value={g.value}>{g.label}</option>
                          ))}
                        </select>
                      </div>

                      <p className="tm-reg-section-title">Documento de identidad</p>
                      <div className="tm-reg-doc-grid">
                        <DocumentUploader
                          label="Documento - Frente"
                          required
                          icon="badge"
                          file={docFrente}
                          onFileChange={setDocFrente}
                          tooltipTitle="Guía — documento frente"
                          tooltipBullets={DOC_GUIDE_BULLETS}
                          guideImage={imgCcFront}
                          guideImageAlt="Ejemplo de fotografía del documento por el frente"
                          inputId="reg-doc-frente"
                        />
                        <DocumentUploader
                          label="Documento - Reverso"
                          required
                          icon="badge"
                          file={docReverso}
                          onFileChange={setDocReverso}
                          tooltipTitle="Guía — documento reverso"
                          tooltipBullets={DOC_GUIDE_BULLETS}
                          guideImage={imgCcBack}
                          guideImageAlt="Ejemplo de fotografía del reverso del documento"
                          inputId="reg-doc-reverso"
                        />
                        <DocumentUploader
                          label="Selfie con Documento"
                          required
                          icon="photo_camera"
                          file={docSelfie}
                          onFileChange={setDocSelfie}
                          tooltipTitle="Guía — selfie con documento"
                          tooltipBullets={DOC_GUIDE_SELFIE_BULLETS}
                          guideImage={imgCcSelfie}
                          guideImageAlt="Ejemplo de selfie sosteniendo el documento junto al rostro"
                          inputId="reg-doc-selfie"
                        />
                      </div>
                    </div>
                  )}

                  <div className="tm-registro-fotos">
                    <label className="tm-registro-label">
                      {modalidad === 'satelite' ? 'Fotos de postulación *' : 'Sube tus fotos *'}
                    </label>
                    <div className="tm-registro-fotos-grid">
                      <label className="tm-registro-file-label">
                        <span className="material-symbols-outlined tm-registro-file-icon">add_a_photo</span>
                        <span className="tm-registro-file-title">Foto Rostro</span>
                        <span className="tm-registro-file-hint">jpg, jpeg ó png</span>
                        {fotoRostro && <span className="tm-registro-file-name">{fotoRostro.name}</span>}
                        <input type="file" accept="image/*" onChange={handleFileRostro} className="tm-registro-file-input" required />
                      </label>
                      <label className="tm-registro-file-label">
                        <span className="material-symbols-outlined tm-registro-file-icon">accessibility_new</span>
                        <span className="tm-registro-file-title">Foto Cuerpo Entero</span>
                        <span className="tm-registro-file-hint">jpg, jpeg ó png</span>
                        {fotoCuerpo && <span className="tm-registro-file-name">{fotoCuerpo.name}</span>}
                        <input type="file" accept="image/*" onChange={handleFileCuerpo} className="tm-registro-file-input" required />
                      </label>
                    </div>
                  </div>

                  <div className="tm-registro-field">
                    <label className="tm-registro-label">Deja tu mensaje</label>
                    <textarea
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={handleChange}
                      className="tm-registro-input tm-registro-textarea"
                      placeholder="Escribe tu mensaje aquí..."
                      rows={3}
                    />
                  </div>

                  <label className="tm-registro-checkbox-label">
                    <input type="checkbox" name="mayorEdad" checked={formData.mayorEdad} onChange={handleChange} className="tm-registro-checkbox" required />
                    <span>Certifico ser <strong>Mayor de Edad (+18)</strong> y acepto el Aviso Legal sobre Protección de Datos Personales.</span>
                  </label>

                  <button type="submit" className="tm-registro-submit btn-hover" disabled={enviando}>
                    {enviando ? 'Enviando...' : 'Enviar Solicitud'}
                  </button>
                </form>
              )}

              <p className="tm-registro-footer-text">TMStudio © Todos los derechos reservados 2026</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default RegistroPage;
